import { nieswiadomyUmyslChapters } from './content';
export const nieswiadomyUmyslFaq = nieswiadomyUmyslChapters.find((chapter) => chapter.title.toLocaleUpperCase('pl').includes('FAQ'));
